import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { Button } from "@/components/ui/button";

const CONTACT_EMAIL = "info@vaultvec.com";
export const MAILTO = `mailto:${CONTACT_EMAIL}?subject=Vaultvec%20enquiry`;

export function MarketingNav() {
  return (
    <header className="fixed top-0 inset-x-0 z-50 glass border-b border-white/10">
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between">
        <Link to="/" data-testid="brand-logo" className="flex items-center gap-2.5">
          <div className="h-8 w-8 bg-primary flex items-center justify-center glow-primary">
            <ShieldCheck className="h-4 w-4 text-white" strokeWidth={1.5} />
          </div>
          <span className="font-heading text-lg font-extrabold tracking-tighter">VAULTVEC</span>
        </Link>
        <nav className="hidden md:flex items-center gap-8 text-sm text-muted-foreground">
          <Link to="/#platform" className="hover:text-foreground transition-colors">Platform</Link>
          <Link to="/#compliance" className="hover:text-foreground transition-colors">Compliance</Link>
          <Link to="/resources" className="hover:text-foreground transition-colors">Resources</Link>
          <Link to="/#pricing" className="hover:text-foreground transition-colors">Pricing</Link>
        </nav>
        <div className="flex items-center gap-3">
          <Link to="/login" data-testid="nav-login-link">
            <Button variant="ghost" className="rounded-sm text-sm hover:bg-white/5">Sign in</Button>
          </Link>
          <Link to="/login">
            <Button data-testid="nav-contact-btn" className="rounded-sm bg-primary hover:bg-primary/90 text-white font-medium glow-primary hover:glow-primary-strong transition-shadow">
              Start free
            </Button>
          </Link>
        </div>
      </div>
    </header>
  );
}

export function MarketingFooter() {
  return (
    <footer className="relative border-t border-white/10">
      <div className="max-w-7xl mx-auto px-6 py-10 flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-2.5">
          <div className="h-7 w-7 bg-primary flex items-center justify-center glow-primary"><ShieldCheck className="h-3.5 w-3.5 text-white" strokeWidth={1.5} /></div>
          <span className="font-heading font-extrabold tracking-tighter">VAULTVEC</span>
        </div>
        <div className="flex items-center gap-6 text-xs text-muted-foreground">
          <Link to="/resources" className="hover:text-foreground transition-colors">Resources</Link>
          <Link to="/compare/acronis-alternative-pharma" className="hover:text-foreground transition-colors">Acronis alternative</Link>
          <Link to="/compare/backup-vendors" className="hover:text-foreground transition-colors">Compare vendors</Link>
          <Link to="/guides/21-cfr-part-11-backup-requirements" className="hover:text-foreground transition-colors">21 CFR Part 11 backups</Link>
        </div>
        <p className="font-mono text-xs text-muted-foreground">© 2026 Vaultvec Systems · Cyber protection for life sciences</p>
      </div>
    </footer>
  );
}

export function useSeoMeta(title, description) {
  if (typeof document !== "undefined") {
    document.title = title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", description);
  }
}
